module.exports = __webpack_public_path__ + "media/images/themes/training-and-coaching-421a42a1e343bb757326fff7ed72d321.png";